var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc_sticky_btns"},[_c('div',{staticClass:"sticky_btn"},[_c('button',{staticClass:"btn btn_circle btn_arrow_u icon-",attrs:{"data-to":"HOME"},on:{"click":_vm.translate}})])])}
var staticRenderFns = []

export { render, staticRenderFns }